import * as React from 'react'
import { Button } from 'react-bootstrap'
import * as FontAwesome from 'react-icons/lib/fa'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { inject } from 'mobx-react'

export interface IExternalDataColumnsLinkProps {
    creditNumber: string
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
export default class ExternalDataColumnsLink extends React.Component<IExternalDataColumnsLinkProps> {

    popupWindow(url: string, title: string, w: number, h: number) {
        var left = screen.width / 2
        var top = 0
        return window
            .open(
                url,
                title,
                'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, ' +
                'copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
            )
    }

    render() {
        const { creditNumber, localizationStore } = this.props

        if (!creditNumber) {
            // return <div></div>
            return (
                <div
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={localizationStore!.t!('CreditNumber0Error')}
                >
                    <FontAwesome.FaChainBroken
                        color="red"
                    />
                </div>)
        }

        return (
            <Button
                data-toggle="tooltip"
                data-placement="bottom"
                title={localizationStore!.t!('OpenInNewTab')}
                onClick={(eBtn) => {
                    eBtn.preventDefault()
                    this.popupWindow(
                        `/externalData/searchByCreditNumber/${creditNumber}`,
                        `Credit Details ${creditNumber}`,
                        screen.width / 2,
                        screen.height
                    )
                }}
            >
                <FontAwesome.FaExternalLink />
            </Button>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataViews/ExternalDataColumnsLink.tsx